export default "__VITE_ASSET__BOEgfnPM__"